<template>
  <div class="py-4 container-fluid">
    <!-- <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'export-excel/rfq?rfq_code='+search.rfq_code+'&vendor_code='+search.vendor_code+'&status='+search.status+''" target="_BLANK"><i class="fa fa-download fa-sm"></i> Export</a> -->
    <!-- <argon-button color="warning" size="sm" class="mb-3" variant="gradient" @click="modalImport()"><i class="fa fa-upload fa-sm"></i> Import</argon-button> -->
    <!-- ======= PANEL ALUR RFQ ======= -->
    <div class="rfq-board mb-4">
      <div class="rfq-head">
        <div class="d-flex align-items-center">
          <div class="rfq-logo"><i class="fas fa-comments-dollar"></i></div>
          <div>
            <h4 class="rfq-title">Request For Quotation</h4>
            <span class="rfq-sub">Kumpulkan penawaran vendor, bandingkan, lalu lanjutkan ke PO</span>
          </div>
        </div>
        <button type="button" class="rfq-add" @click="formSub.title ='==== TRANSACTION RFQ ADD DATA ====', createItem()"><i class="fas fa-plus"></i> RFQ Baru</button>
      </div>

      <!-- alur proses -->
      <div class="flow">
        <div v-for="(st, i) in flowSteps" :key="st.key" class="flow-step" :class="['fs-' + st.key, { active: st.status && search.status == st.status, clickable: st.status }]" @click="st.status && quickStatus(search.status == st.status ? '' : st.status)">
          <span class="flow-no">{{ i + 1 }}</span>
          <i class="flow-icon" :class="st.icon"></i>
          <span class="flow-val">{{ (st.value || 0).toLocaleString('id-ID') }}</span>
          <span class="flow-lbl">{{ st.label }}</span>
          <span class="flow-hint">{{ st.hint }}</span>
        </div>
      </div>

      <!-- insight -->
      <div class="insight-row">
        <div class="insight">
          <div class="gauge" :style="{ '--p': quotedPct }"><span>{{ quotedPct }}%</span></div>
          <div>
            <span class="ins-title">Cakupan Penawaran</span>
            <span class="ins-note">{{ (rs.summary.items_quoted || 0).toLocaleString('id-ID') }} dari {{ (rs.summary.rfq_items || 0).toLocaleString('id-ID') }} item RFQ sudah ada harga</span>
          </div>
        </div>
        <div class="insight">
          <div class="gauge gauge-green" :style="{ '--p': comparePct }"><span>{{ comparePct }}%</span></div>
          <div>
            <span class="ins-title">Bisa Dibandingkan</span>
            <span class="ins-note">{{ (rs.summary.items_compare || 0).toLocaleString('id-ID') }} item punya penawaran dari 2 vendor atau lebih</span>
          </div>
        </div>
        <div class="insight">
          <div class="ins-big"><b>{{ rs.summary.avg_vendors || 0 }}</b><i class="fas fa-store"></i></div>
          <div>
            <span class="ins-title">Rata-rata Vendor / RFQ</span>
            <span class="ins-note">Makin banyak vendor, makin kuat posisi tawar</span>
          </div>
        </div>
        <div class="insight insight-warn" :class="{ on: search.due == 'overdue' }" @click="quickDue(search.due == 'overdue' ? '' : 'overdue')">
          <div class="ins-big ins-big-warn"><b>{{ rs.summary.overdue_draft || 0 }}</b><i class="fas fa-hourglass-end"></i></div>
          <div>
            <span class="ins-title">Draf Lewat Batas</span>
            <span class="ins-note">RFQ masih Draf padahal due date penawaran sudah lewat. Klik untuk melihat.</span>
          </div>
        </div>
        <div class="insight insight-vendors">
          <span class="ins-title mb-1"><i class="fas fa-medal text-warning"></i> Vendor Paling Sering Diundang</span>
          <div v-for="v in rs.topVendors" :key="v.vendor_code" class="tv-row" @click="quickSearch(v.company_name)" :title="'Tampilkan RFQ dengan vendor ' + v.company_name">
            <span class="tv-name">{{ v.company_name }}</span>
            <span class="tv-bar"><span :style="{ width: (v.rfq_count / ((rs.topVendors[0] || {}).rfq_count || 1) * 100) + '%' }"></span></span>
            <span class="tv-val">{{ v.rfq_count }} RFQ</span>
          </div>
        </div>
      </div>
    </div>

    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="card-header pb-2">
              <div class="row align-items-center">
                <div class="col-xl-4 col-lg-12 mb-2">
                  <div class="input-group">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                    <input type="text" class="form-control" placeholder="Cari kode RFQ, no. PR, vendor, nama item, pembuat..." v-model="search.q" @input="onSearch()">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-12 mb-2 d-flex flex-wrap align-items-center justify-content-xl-end gap-2">
                  <div class="status-pills">
                    <button v-for="st in statusTabs" :key="st.value" type="button" :class="['sp-' + st.key, { on: search.status == st.value && !search.due }]" @click="quickStatus(st.value)">{{ st.label }}</button>
                  </div>
                  <argon-button variant="gradient" color="secondary" size="sm" @click="filter()"><i class="fa fa-filter fa-sm"></i> Filter</argon-button>
                  <argon-button variant="gradient" color="success" size="sm" @click="formSub.title ='==== TRANSACTION RFQ ADD DATA ====', createItem()"><i class="fa fa-plus fa-sm"></i> Add New</argon-button>
                </div>
              </div>
              <div v-if="activeChips.length" class="mt-1">
                <span v-for="chip in activeChips" :key="chip.key" class="badge bg-light text-dark me-2 filter-chip" @click="clearFilter(chip.key)">{{ chip.label }} <i class="fa fa-times ms-1"></i></span>
                <span class="text-xs text-primary filter-chip" @click="resetFilter()">Hapus semua filter</span>
              </div>
              <div class="quote-legend mt-1">
                <span class="text-xxs text-secondary me-1">Bar penawaran per item:</span>
                <span><i class="ql-compare"></i>2+ vendor (bisa dibandingkan)</span>
                <span><i class="ql-single"></i>baru 1 vendor</span>
                <span><i class="ql-none"></i>belum ada harga</span>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-0 scroll">
                <table class="table table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">RFQ CODE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">MAT / SRV GRP</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">DUE DATE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">NOTE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PENAWARAN</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">STATUS</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">CREATED AT</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">CREATED BY</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!onLoading && !table.data.length"><td colspan="10" class="text-center text-sm text-secondary py-5">Tidak ada RFQ yang cocok dengan filter</td></tr>
                    <tr v-for="(row, i) in table.data" :key="i">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ (pagination.page - 1) * 100 + i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm" @click="getDetailTransaction(row.safety_code)" style="cursor: pointer;">
                        <span class="badge badge-sm bg-gradient-primary">  {{ row.rfq_code }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase"> {{ row.material_group_code }} - {{ row.group_name }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase d-block">  {{ moment(row.due_date).locale('id').format('LL') }} </span>
                        <span v-if="dueInfo(row)" class="due-chip" :class="'dc-' + dueInfo(row).level">{{ dueInfo(row).label }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.note }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <div class="quote-cell" :title="quoteTitle(row)">
                          <div class="quote-top">
                            <span><i class="fas fa-store"></i> {{ (row.quote || {}).vendors || 0 }} vendor</span>
                            <span><i class="fas fa-box"></i> {{ row.total_item_count }} item</span>
                          </div>
                          <div class="quote-bar">
                            <span class="qb-compare" :style="{ width: quoteSeg(row).compare + '%' }"></span>
                            <span class="qb-single" :style="{ width: quoteSeg(row).single + '%' }"></span>
                          </div>
                          <div class="quote-bottom">
                            <span>{{ Math.min((row.quote || {}).items_quoted || 0, row.total_item_count) }}/{{ row.total_item_count }} item ada harga</span>
                            <span v-if="(row.quote || {}).items_po" class="po-chip">PO {{ Math.min(row.quote.items_po, row.total_item_count) }}/{{ row.total_item_count }}</span>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm" :class="statusClass(row.status)"> {{ row.status }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ moment(row.created_at).locale('id').format('LL') }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.created_by }} </span>
                      </td>
                      <td class="align-middle text-center">
                        <router-link :to="{ name: 'FormRfqVendor', params: {code: row.safety_code }}">
                          <i class="far fa-address-card text-info" aria-hidden="true" title="Isi/lihat penawaran vendor" style="cursor: pointer; margin-right: 20px;" ></i>
                        </router-link>
                        <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus RFQ ini" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id, row.total_item_count, row.transaction_type)" v-if="row.status == 'Draf'"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- ====================================================================  MODAL PRIVIEW  ============================================================================== -->
  <div class="container">
    <vue-final-modal v-model="formSub.show" classes="modal-container" content-class="modal-content-width" :z-index="10000" :focus-retain="false">
      <!-- header -->
      <div class="row">
        <div class="col-11 text-center">
          <span class="modal__title">{{formSub.title}} <template v-if="headerData.transaction_type">{{ headerData.transaction_type.toUpperCase() }} ====</template></span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formSub.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <div class="row">
          <div class="col-10 text-center">
          </div>
          <div class="col-2 float-right">
            <!-- <a class="btn btn-sm btn-warning" style="margin-left: 0px;" :href="apiUrl+'print-pdf/rfq-detail?rfq_code='+headerData.rfq_no+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a> -->
          </div>
        </div>
        <table class="table table-sm table-bordered">
          <tbody>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> RFQ NUMBER </td>
              <td colspan="4"> <input type="text" class="form-control" placeholder="PR NO" v-model="headerData.rfq_no" disabled> </td>
            </tr>
            <!-- <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> VENDOR CODE <span style="color: red;">*</span></td>
              <td colspan="3"> 
                <multiselect v-model="headerData.vendor_code" :options="tableVendor.data" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Vendor Code" label="vendor_code" track-by="vendor_code" :preselect-first="true" @keyup="getVendor" :custom-label="nameWithLangVendor">
                  <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
                </multiselect> 
              </td>
            </tr> -->
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> DUE DATE <span style="color: red;">*</span></td>
              <td> <input type="date" class="form-control" placeholder="Due Date" v-model="headerData.due_date"> </td>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> STATUS <span style="color: red;">*</span></td>
              <td> <input type="text" class="form-control" placeholder="Status" v-model="headerData.status" disabled> </td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> NOTE </td>
              <td colspan="4"> <input type="text" class="form-control" placeholder="General Note" v-model="headerData.note"> </td>
            </tr>
          </tbody>
        </table>
          <!-- ===== FOR ITEM LIST ===== -->
          <div>
            <div class="">
              <hr style="border: 2px solid #008000;">
              <div class="row mb-2">
                <div class="col-4">
                  <div class="card-header pb-0">
                    <h6><i class="fas fa-list-ol" style="margin-right: 10px;"></i> Item List</h6>
                  </div>
                </div>
                <div class="col-3">
                </div>
                <div class="col-5 float-right">
                  <argon-button
                    style="margin-right: 10px; margin-left: 60px;"
                    class="mt-4"
                    variant="gradient"
                    color="warning"
                    size="sm"
                    :disabled="headerData.status == 'RFQ Completed'"
                    @click="rfqApproved(headerData.rfq_no)"
                  ><i class="far fa-check-circle" aria-hidden="true"></i> Rfq Completed</argon-button>
                  <argon-button
                    class="mt-4"
                    variant="gradient"
                    color="success"
                    size="sm"
                    :disabled="headerData.status == 'RFQ Completed'"
                    @click="createItem()"
                  ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
                </div>
              </div>
              <div class="table-responsive p-0 scroll-model">
                <table class="table table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr style="background-color: #F0F8FF;">
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Image</th> -->
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PR Code</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Part Name</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Specification</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Size</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Unit</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Qty</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Weight</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">MPS NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">USE FOR</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">STATUS</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in dataListItem.data" :key="i">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ i + 1 }}</span>
                      </td>
                      <!-- <td class="align-middle text-center text-sm">
                        <img
                          :src="storageUrl+'/image_warehouse/'+row.image"
                          class="avatar avatar-lg me-1"
                          alt="user1"
                        />
                      </td> -->
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm bg-gradient-primary">  {{ row.pr_code }} <span v-if="row.total_revision"> (Rev. {{ row.total_revision }})</span></span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.part_name }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.specification }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.size }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.unit }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.qty }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.weight }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.mps_no }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.item_no }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.use_for }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge bg-gradient-info">{{ row.status }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <!-- <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="editItem(row.id)" title="Edit"></i> -->
                        <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer; margin-right: 20px;" @click="removeItem(row.id)" v-if="headerData.status != 'RFQ Completed'"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr style="background-color: yellow; height: 10px;">

              <!-- LIST VENDOR YANG SUDAH MENGISI HARGA -->
              <div class="row mb-2">
                <div class="col-4">
                  <div class="card-header pb-0">
                    <h6><i class="fas fa-list-ol" style="margin-right: 10px;"></i> Vendor List</h6>
                  </div>
                </div>
                <div class="col-3">
                </div>
                <div class="col-5 float-right" v-if="headerData.safety_code">
                  <router-link :to="{ name: 'FormRfqVendor', params: {code: headerData.safety_code }}">
                    <argon-button
                      class="mt-4"
                      variant="gradient"
                      color="success"
                      size="sm"
                    ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add Vendor</argon-button>
                  </router-link>
                </div>
              </div>
              <div class="table-responsive p-0 scroll-model">
                <table class="table table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">No</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Vendor</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Part Name</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Specification</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Size</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Qty</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Unit Price</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Amount</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Other Cost</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Other Cost Description</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Discount</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Price</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Del Condition</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Del Time</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Payment Terms</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Manufacture</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Remark</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #008000">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in dataListVendor.data" :key="i">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.company_name }}</span>
                  <span class="badge badge-sm bg-gradient-danger ms-1" v-if="row.vendor_status == 'Blacklist'" title="Vendor ini berstatus BLACKLIST di Vendor Management">Blacklist</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.part_name }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.specification }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.size }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.qty }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.unit_price) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.amount) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.other_cost) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.other_cost_description) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ convertRp(row.discount) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.price }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.del_condition }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ moment(row.del_time).locale('id').format('LL') }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.payment_terms }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.manufacture }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.remark }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus penawaran vendor ini" style="cursor: pointer; margin-right: 20px;" @click="removeVendor(row.id)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
        </div>
        <div class="col-1">
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- ====================================================================  MODAL ADD ITEM  ========================================================================== -->
  <div class="container">
    <vue-final-modal v-model="formAddItem.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formAddItem.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formAddItem.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Search PR Items Available: </label>
        <input type="text" class="form-control mb-3" placeholder="Keyword : PR No / Material Group / Part Name" @keyup="searchPr()" v-model="itemData.pr_item_code">
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0">
            <thead>
              <tr style="background-color: #F0F8FF;">
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">No</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">Action</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">Pr No</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">MAT / SRVC GRP</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">Date Required</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">Part Name</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">Specification</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">Size</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">Unit</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">Qty</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">Weight</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">MPS NO</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">ITEM NO</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">USE FOR</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">STATUS</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="background-color: #5F9EA0">Created By</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableSearchaPr.data" :key="i">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ i + 1 }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <i class="fa fa-plus-square text-primary" title="Add Material" style="cursor: pointer;" @click="addItemPr(row.item_pr_code)"></i>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="badge bg-gradient-primary">{{ row.pr_code }}</span>
                </td>
                <td class="align-middle text-left text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.material_group_code }} - {{ row.group_name }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ moment(row.date_required).locale('id').format('LL') }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.part_name }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.specification }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.size }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.unit }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.qty }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.weight }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.mps_no }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.item_no }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.use_for }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="badge bg-gradient-info">{{ row.status }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.created_by }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr style="background-color: red; height: 10px;">

        <!-- DATA ADD ITEM -->
        <table class="table table-sm table-bordered">
          <tbody>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> RFQ NUMBER </td>
              <td colspan="4"> <input type="text" class="form-control" placeholder="PR NO" v-model="headerData.rfq_no" disabled> </td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> DUE DATE <span style="color: red;">*</span></td>
              <td> <input type="date" class="form-control" placeholder="Due Date" v-model="headerData.due_date"> </td>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> STATUS </td>
              <td> <input type="text" class="form-control" placeholder="Status" v-model="headerData.status" disabled></td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> NOTE </td>
              <td colspan="4"> <input type="text" class="form-control" placeholder="General Note" v-model="headerData.note"> </td>
            </tr>
          </tbody>
        </table>
        <div class="table-responsive p-0 scroll">
          <table class="table table-hover table-striped align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PR Code</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Part Name</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Specification</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Size</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Unit</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Qty</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Weight</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">MPS NO</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM NO</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">USE FOR</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">STATUS</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in dataListItem.data" :key="i">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ i + 1 }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="badge badge-sm bg-gradient-primary">  {{ row.pr_code }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.part_name }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.specification }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.size }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.unit }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.qty }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.weight }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.mps_no }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.item_no }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.use_for }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="badge bg-gradient-info">{{ row.status }}</span>
                </td>
                <td class="align-middle text-center">
                  <!-- <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="editItem(row.id)" title="Edit"></i> -->
                  <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer; margin-right: 20px;" @click="removeItem(row.id)" v-if="headerData.status === 'Draf'"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
        </div>
        <div class="col-1">
          <!-- <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formAddItem.show = false, createWithSubForm()">Close</argon-button> -->
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- ================================================  MODAL FILTER ============================================== -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">RFQ Code </label>
        <input type="text" class="form-control" placeholder="RFQ Code" v-model="search.rfq_code" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Due Date </label>
        <multiselect v-model="search.material_group_code" :options="tableMaterialGroupPR.data" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Material / Service Group PR" label="material_group_code" track-by="material_group_code" :preselect-first="true" @keyup="getMaterialGroupPR" :custom-label="nameWithLangMGPr">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect> 
        <label for="example-text-input" class="form-control-label mt-3">Due Date </label>
        <input type="date" class="form-control" placeholder="Due Date" v-model="search.due_date" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Note </label>
        <input type="text" class="form-control" placeholder="Note" v-model="search.note" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Status </label>
        <select class="form-select" aria-label="Default select example" v-model="search.status">
          <option value="Draf">Draf</option>
          <option value="On Comparison">On Comparison</option>
          <option value="RFQ Approved">RFQ Approved</option>
          <option value="RFQ Completed">RFQ Completed</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Date Range</label> 
        <flat-pickr :config="{ mode: 'range',}" class="form-control mb-4" v-model="search.date"/>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="resetFilter()">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="reload()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span>Filter</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>

</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css';
var moment = require('moment');

const EMPTY_SEARCH = { q: '', due: '', rfq_code: '', material_group_code: '', due_date: '', note: '', status: '', date: '' };
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import requestForQuotation from '@/services/procurement/requestForQuotation.service';
import purchasingRequisition from '@/services/procurement/purchasingRequisition.service';
import materialGroupPR from '@/services/procurement/materialGroupPR.service';
import vendorList from '@/services/procurement/vendorList.service';

export default {
  name: "tables",
  components: {
    ArgonButton,
    VueFinalModal,
    Multiselect,
    BasePagination,
    flatPickr,
  },
  data() {
    return {
      pagination: {
        page_count: '',
        page: 1,
      },
      moment:moment,
      table: {
        data: []
      },
      totalTask: '',
      totalRfqDraft: '',
      totalRfqCompleted: '',
      totalRfqItems: '',
      formSub: {
        add: true,
        title: "==== TRANSACTION RFQ DETAIL ====",
        show: false
      },
      formAddItem: {
        add: true,
        title: "==== TRANSACTION RFQ DETAIL ====",
        show: false
      },
      formImport: {
        add: true,
        title: "Import Data Setting Approval",
        show: false
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      dataImport: '',
      onLoading: false,
      tabelError: {
        data: []
      },
      storageUrl : config.storageUrl,
      headerData: {},
      search: { ...EMPTY_SEARCH },
      searchTimer: null,
      requestSeq: 0,
      rs: { pipeline: {}, summary: {}, topVendors: [] },
      statusTabs: [
        { key: 'all', value: '', label: 'Semua' },
        { key: 'draft', value: 'Draf', label: 'Draf' },
        { key: 'comparison', value: 'On Comparison', label: 'On Comparison' },
        { key: 'approved', value: 'RFQ Approved', label: 'RFQ Approved' },
        { key: 'completed', value: 'RFQ Completed', label: 'RFQ Completed' },
      ],
      apiUrl :config.apiUrl,
      tableVendor: {
        data: []
      },
      tableMaterialGroupPR: {
        data: []
      },
      tableSearchaPr: {
        data: []
      },
      tableItem: {
        data: []
      },

      // ----- Item Transaction RFQ -----
      dataTransaction: {},
      dataListItem: {
        data: []
      },
      dataListVendor: {
        data: []
      },
      itemData: {},
    };
  },
  computed: {
    flowSteps() {
      const p = this.rs.pipeline || {};
      return [
        { key: 'ready', label: 'Item PR Siap RFQ', hint: 'PR Approved, belum dibuat RFQ', value: p.pr_ready, icon: 'fas fa-inbox', status: '' },
        { key: 'draft', label: 'Draf', hint: 'Menunggu penawaran vendor', value: p.draft, icon: 'fas fa-paper-plane', status: 'Draf' },
        { key: 'comparison', label: 'On Comparison', hint: 'Penawaran sedang dibandingkan', value: p.comparison, icon: 'fas fa-balance-scale', status: 'On Comparison' },
        { key: 'approved', label: 'RFQ Approved', hint: 'Vendor terpilih disetujui', value: p.approved, icon: 'fas fa-check-double', status: 'RFQ Approved' },
        { key: 'completed', label: 'RFQ Completed', hint: 'Selesai, lanjut ke PO', value: p.completed, icon: 'fas fa-flag-checkered', status: 'RFQ Completed' },
      ];
    },
    quotedPct() {
      const sm = this.rs.summary || {};
      return sm.rfq_items ? Math.min(100, Math.round(sm.items_quoted / sm.rfq_items * 100)) : 0;
    },
    comparePct() {
      const sm = this.rs.summary || {};
      return sm.rfq_items ? Math.min(100, Math.round(sm.items_compare / sm.rfq_items * 100)) : 0;
    },
    activeChips() {
      const chips = [];
      if (this.search.rfq_code) chips.push({ key: 'rfq_code', label: 'RFQ: ' + this.search.rfq_code });
      if (this.search.material_group_code && this.search.material_group_code.material_group_code) chips.push({ key: 'material_group_code', label: 'Group: ' + this.search.material_group_code.material_group_code });
      if (this.search.due_date) chips.push({ key: 'due_date', label: 'Due: ' + this.search.due_date });
      if (this.search.note) chips.push({ key: 'note', label: 'Note: ' + this.search.note });
      if (this.search.date) chips.push({ key: 'date', label: 'Dibuat: ' + this.search.date });
      if (this.search.due == 'overdue') chips.push({ key: 'due', label: 'Draf lewat batas' });
      return chips;
    },
  },
  mounted(){
    this.getStats();
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    nameWithLangVendor ({ vendor_code, company_name, status }) {
      return `${vendor_code} - ${company_name}` + (status == 'Blacklist' ? ' [BLACKLIST]' : '')
    },
    nameWithLangMGPr ({ material_group_code, group_name }) {
      return `${material_group_code} - ${group_name}`
    },
    get(param){
      let context = this; 
      context.onLoading = true;

      const seq = ++context.requestSeq;
      Api(context, requestForQuotation.index({q: this.search.q, due: this.search.due, rfq_code: this.search.rfq_code, material_group_code: (this.search.material_group_code || {})['material_group_code'], due_date: this.search.due_date, note: this.search.note, status: this.search.status, date: this.search.date, page: context.pagination.page})).onSuccess(function(response) {
          if (seq != context.requestSeq) return;
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page
          
          context.totalTask             = response.data.data.task;
          context.totalRfqDraft         = response.data.data.rfqDraft;
          context.totalRfqCompleted     = response.data.data.rfqCompleted;
          context.totalRfqItems         = response.data.data.rfqItems;

          // context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {
          if (seq != context.requestSeq) return;
          context.table.data = [];
          if (!error.response || error.response.status != 404) {
              context.notify('Data Retrieved Failed', 'error')
          }
      }).onFinish(function() {
         context.formFilter.show = false;
         if (seq == context.requestSeq) context.onLoading = false;
      })
      .call()
    },
    getVendor(param){
      if (param.target.value.length >= 3) {
        let context = this;        
        Api(context, vendorList.getVendor({search: param.target.value})).onSuccess(function(response) {    
            context.tableVendor.data = response.data.data;
        }).onError(function(error) {                    
            if (error.response.status == 404) {
                context.tableVendor.data = [];
            }
        }).onFinish(function() { 
        })
        .call()
      }
    },
    getMaterialGroupPR(param){
      if (param.target.value.length >= 1) {
        let context = this;        
        Api(context, materialGroupPR.getMaterialGroupPR({search: param.target.value})).onSuccess(function(response) {    
            context.tableMaterialGroupPR.data = response.data.data;
        }).onError(function(error) {                    
            if (error.response.status == 404) {
                context.tableMaterialGroupPR.data = [];
            }
        }).onFinish(function() { 
        })
        .call()
      }
    },
    searchPr(){
      let context = this;              
      Api(context, purchasingRequisition.searchPr({search : context.itemData.pr_item_code})).onSuccess(function(response) {   
          context.tableSearchaPr.data = response.data.data;
      })
      .call()
    },
    getDetailTransaction(trxnumber){
      let context = this;               
      Api(context, requestForQuotation.transactionDetail({safety_code: trxnumber, page: ''})).onSuccess(function(response) {    
          context.headerData.id          = response.data.data.data.id;
          context.headerData.rfq_no      = response.data.data.data.rfq_code;
          context.headerData.safety_code = response.data.data.data.safety_code;
          context.headerData.due_date    = response.data.data.data.due_date;
          context.headerData.note        = response.data.data.data.note;
          context.headerData.status      = response.data.data.data.status;

          context.headerData.vendor_code = response.data.data.dataVendor;

          context.dataListItem.data   = response.data.data.dataListItem;
          context.dataListVendor.data = response.data.data.dataListVendor;

          context.formSub.add   = true;
          context.formSub.show  = true;
          context.formSub.title = "==== TRANSACTION RFQ DETAIL ====";

          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.headerData = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
      })
      .call()
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.pagination.page  = 1 ;
    },
    createWithSubForm() {
      this.formSub.add       = true;
      this.formSub.show      = true;
      this.formSub.title     = "==== TRANSACTION RFQ ADD DATA ====";
      this.headerData        = {};
      this.headerData.status = 'Draf'
      this.dataListItem.data = {}
      // this.generateRfqCode()
    },
    createItem() {
      this.formAddItem.add   = true;
      this.formAddItem.show  = true;
      this.formAddItem.title = "Add Item";
      this.itemData          = {};
      this.itemData.pr_item_code = ''
      if (this.formSub.title != "==== TRANSACTION RFQ DETAIL ====") {
        this.generateRfqCode()
        this.headerData        = {};
        this.headerData.status = 'Draf'
        this.dataListItem.data = {}
        this.defaultDueDate()
      }
      this.searchPr()
    },
    editItem(id) {
      let context = this;               
      Api(context, requestForQuotation.showItem(id)).onSuccess(function(response) {
          context.itemData          = response.data.data;
          context.itemData.id_item  = response.data.data.id;
          context.formAddItem.show  = true;
          context.formAddItem.title = 'Edit Data';   
      })
      .call()        
    },
    filesChange(e) {
      this.headerData.attachment = e.target.files[0];
    },
    generateRfqCode(){
      let context = this;              
      Api(context, requestForQuotation.generateRfqCode()).onSuccess(function(response) {   
          context.headerData.rfq_no      = response.data.data.RfqCode;
          context.headerData.safety_code = response.data.data.safetyCode
      })
      .call()
    },
    addItemPr(item_pr_code){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      // INSERT HEADER
      if (context.headerData.rfq_no != undefined && context.headerData.safety_code != undefined && context.headerData.due_date != undefined && context.headerData.status != undefined ) {
        formData.append('rfq_no', context.headerData.rfq_no);
        formData.append('safety_code', context.headerData.safety_code);
        formData.append('vendor_code', JSON.stringify(context.headerData.vendor_code));
        formData.append('due_date', context.headerData.due_date);
        formData.append('status', context.headerData.status);
        formData.append('note', (context.headerData.note == undefined) ? '-' : context.headerData.note);
        // rfq item code
        formData.append('item_pr_code', item_pr_code);
      }else{
        return alert('The Red Star Field is Mandatory')
      }

      if (context.formSub.title == '==== TRANSACTION RFQ ADD DATA ') {
          api = Api(context, requestForQuotation.create(formData));
      } else {
          api = Api(context, requestForQuotation.create(formData));
      }
      api.onSuccess(function(response) {
        context.notify((context.formSub.title === '==== TRANSACTION RFQ ADD DATA ') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function(error) { 
        context.notify((context.formSub.title != '==== TRANSACTION RFQ ADD DATA ') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() { 
        context.searchPr() 
        context.getDetailTransaction(context.headerData.safety_code);
        context.get();
      })
      .call();
    },
    remove(id, total_item, transaction_type) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        // if ((transaction_type == 'Reduction') || (total_item == 0)) {
          let context = this;
          Api(context, requestForQuotation.delete(id)).onSuccess(function(response) {
            context.get();
            context.getStats();
            context.notify('Data Successfully Deleted', 'success')
          }).call();
        // }else{
          // this.notify('Failed to delete. Please clear items first', 'error')
        // }
      }
    },
    removeItem(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context  = this;

        Api(context, requestForQuotation.deleteItem(id)).onSuccess(function(response) {
          context.getDetailTransaction(context.headerData.safety_code);
          context.get();
          context.searchPr();
          context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    removeVendor(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context  = this;

        Api(context, requestForQuotation.deleteVendor(id)).onSuccess(function(response) {
          context.getDetailTransaction(context.headerData.safety_code);
          context.get();
          context.searchPr();
          context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    rfqApproved(param){
      let api      = null;
      let context  = this;

      api = Api(context, requestForQuotation.rfqApproved({rfq_code: param}));
      api.onSuccess(function(response) {
        context.get();
        context.getStats();
        context.getDetailTransaction(context.headerData.safety_code)
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
      })
      .call();
    },
    modalImport(){
      this.formImport.show  = true;
      this.formImport.title = "Import Data Setting Approval";
      this.tabelError.data  = [];
    },
    filesChangeImport(e) {
        this.dataImport = e.target.files[0];
    },
    importData(){
      let api = null;
      let context = this;
      let formData = new FormData();
      this.onLoading = true;

      if (this.dataImport != undefined) {
        formData.append('import_data', this.dataImport);
      }else{
        return alert('File Import Not Found')
      }

      api = Api(context, requestForQuotation.import(formData));
      api.onSuccess(function(response) {
          context.onLoading = false;
          context.get();
          context.formImport.show = false;
          context.notify('Import Data Success', 'success')
      }).onError(function(error) {      
          context.tabelError.data = error.response.data.data;              
          context.notify('Import Data Failed', 'error')
          context.onLoading = false;
      }).onFinish(function() {  
      })
      .call();
    },
    copyLink(link) {
      navigator.clipboard.writeText('http://localhost:8081/proc-form-rfq-vendor/'+link);
      try {
        this.notify('Contents Successfully Copied', 'success')
      }catch (err) {
        this.notify('Content Failed To Copied', 'error')
      }
    },
    defaultDueDate(){
      var date  = new Date(+new Date + 12096e5);
      var day   = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var today = date.getFullYear() + "-" + (month) + "-" + (day);

      this.headerData.due_date = today
    },
    getStats() {
      let context = this;
      Api(context, requestForQuotation.stats()).onSuccess(function(response) {
        context.rs = response.data.data;
      }).call();
    },
    reload() {
      this.pagination.page = 1;
      this.get();
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.reload(), 400);
    },
    quickSearch(text) {
      this.search.q = text;
      this.reload();
    },
    quickStatus(status) {
      this.search.status = status;
      this.search.due = '';
      this.reload();
    },
    quickDue(due) {
      this.search.due = due;
      this.search.status = '';
      this.reload();
    },
    clearFilter(key) {
      this.search[key] = '';
      this.reload();
    },
    resetFilter() {
      this.search = { ...EMPTY_SEARCH };
      this.formFilter.show = false;
      this.reload();
    },
    // lebar bar penawaran: item dgn 2+ vendor, item dgn 1 vendor, sisanya belum ada harga
    quoteSeg(row) {
      const q = row.quote || {};
      const total = row.total_item_count || 0;
      if (!total) return { compare: 0, single: 0 };
      const compare = Math.min(q.items_compare || 0, total);
      const single = Math.max(0, Math.min(q.items_quoted || 0, total) - compare);
      return { compare: compare / total * 100, single: single / total * 100 };
    },
    quoteTitle(row) {
      const q = row.quote || {};
      return (q.vendors || 0) + ' vendor diundang, ' + (q.quotes || 0) + ' harga masuk\n'
        + (q.items_compare || 0) + ' item bisa dibandingkan (2+ vendor)\n'
        + (q.items_po || 0) + ' item sudah jadi PO';
    },
    // batas penawaran hanya relevan selama RFQ masih Draf
    dueInfo(row) {
      if (row.status != 'Draf' || !row.due_date) return null;
      const diff = moment(row.due_date).startOf('day').diff(moment().startOf('day'), 'days');
      if (diff < 0) return { level: 'over', label: 'Lewat ' + Math.abs(diff) + ' hari' };
      if (diff == 0) return { level: 'soon', label: 'Hari ini' };
      if (diff <= 3) return { level: 'soon', label: diff + ' hari lagi' };
      return { level: 'ok', label: diff + ' hari lagi' };
    },
    statusClass(status) {
      const map = { 'Draf': 'bg-gradient-secondary', 'On Comparison': 'bg-gradient-info', 'On Comparasion': 'bg-gradient-info', 'RFQ Approved': 'bg-gradient-primary', 'RFQ Completed': 'bg-gradient-success' };
      return map[status] || 'bg-gradient-dark';
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },
    convertRp(bilangan) {
      if (bilangan) {
        // var number_string = bilangan.toString(),
        //     sisa    = number_string.length % 3,
        //     rupiah  = number_string.substr(0, sisa),
        //     ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        // if(ribuan){
        //   var separator = sisa ? '.' : '';
        //   rupiah += separator + ribuan.join('.');
        //   return rupiah
        // }else{
        //   return bilangan
        // }

        var data =  Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR"
        }).format(bilangan);
        
        return data.substr(3)
      }

    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
/*MODAL WIDTH KUSUS LEBAR BESAR*/
::v-deep .modal-content-width {
  /*display: flex;*/
  /*flex-direction: column;*/
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1090px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll {
  overflow: auto;
  max-height: 600px;
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
.scroll-model { 
  overflow: auto; 
}
.scroll-model thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
/* ===== panel alur RFQ (gaya terang) ===== */
.rfq-board {
  position: relative; border-radius: 22px; padding: 22px 24px 20px; overflow: hidden;
  background: linear-gradient(160deg, #ffffff 0%, #f3f8ff 55%, #eafaf6 100%);
  box-shadow: 0 10px 30px rgba(17, 105, 142, .10);
  border: 1px solid #e3edf7;
}
.rfq-board::before {
  content: ''; position: absolute; right: -60px; top: -60px; width: 220px; height: 220px; border-radius: 50%;
  background: radial-gradient(circle, rgba(17, 205, 239, .18), transparent 70%);
}
.rfq-head { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; position: relative; }
.rfq-logo {
  width: 48px; height: 48px; border-radius: 14px; margin-right: 14px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-size: 20px; color: #fff;
  background: linear-gradient(135deg, #11cdef, #1171ef); box-shadow: 0 6px 14px rgba(17, 113, 239, .3);
}
.rfq-title { margin: 0; font-weight: 800; color: #1d3557; letter-spacing: -.01em; }
.rfq-sub { font-size: .8rem; color: #6c7a91; }
.rfq-add {
  border: none; border-radius: 12px; height: 40px; padding: 0 18px; font-size: .82rem; font-weight: 700; color: #fff;
  background: linear-gradient(135deg, #2dce89, #1aae6f); box-shadow: 0 6px 14px rgba(45, 206, 137, .3);
}
.rfq-add:hover { filter: brightness(1.05); }

/* alur proses: 5 langkah tersambung panah */
.flow { display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px; margin: 20px 0 16px; position: relative; }
@media (max-width: 992px) { .flow { grid-template-columns: repeat(2, 1fr); } }
.flow-step {
  position: relative; background: #fff; border-radius: 16px; padding: 14px 14px 12px; border: 2px solid transparent;
  box-shadow: 0 3px 10px rgba(29, 53, 87, .06); transition: transform .15s, box-shadow .15s, border-color .15s;
  display: flex; flex-direction: column;
}
.flow-step:not(:last-child)::after {
  content: '\f054'; font-family: 'Font Awesome 5 Free'; font-weight: 900; font-size: 11px;
  position: absolute; right: -13px; top: 50%; transform: translateY(-50%); z-index: 2;
  width: 22px; height: 22px; border-radius: 50%; background: #fff; color: #9fb3c8;
  display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0,0,0,.08);
}
@media (max-width: 992px) { .flow-step::after { display: none; } }
.flow-step.clickable { cursor: pointer; }
.flow-step.clickable:hover { transform: translateY(-3px); box-shadow: 0 10px 20px rgba(29, 53, 87, .10); }
.flow-step.active { border-color: currentColor; }
.flow-no { position: absolute; top: 10px; right: 12px; font-size: .62rem; font-weight: 800; color: #b8c4d4; }
.flow-icon { font-size: 18px; margin-bottom: 6px; }
.flow-val { font-size: 1.6rem; font-weight: 800; line-height: 1.1; color: #1d3557; }
.flow-lbl { font-size: .74rem; font-weight: 700; }
.flow-hint { font-size: .64rem; color: #8a98ac; }
.fs-ready { color: #8965e0; }
.fs-draft { color: #8392ab; }
.fs-comparison { color: #11a3c9; }
.fs-approved { color: #5e72e4; }
.fs-completed { color: #1aae6f; }
.flow-step .flow-val { color: #1d3557; }
.fs-ready { background: linear-gradient(180deg, #f6f1ff, #fff); }
.fs-completed { background: linear-gradient(180deg, #ebfbf3, #fff); }

/* insight */
.insight-row { display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1.6fr; gap: 12px; }
@media (max-width: 1400px) { .insight-row { grid-template-columns: repeat(2, 1fr); } .insight-vendors { grid-column: 1 / -1; } }
.insight { display: flex; gap: 12px; align-items: center; background: rgba(255,255,255,.75); border-radius: 14px; padding: 12px 14px; border: 1px dashed #d7e3f0; }
.insight-vendors { flex-direction: column; align-items: stretch; gap: 3px; }
.insight-warn { cursor: pointer; transition: background .15s; }
.insight-warn:hover, .insight-warn.on { background: #fff4ec; border-color: #fbb140; }
.ins-title { display: block; font-size: .74rem; font-weight: 800; color: #1d3557; }
.ins-note { display: block; font-size: .66rem; color: #7b8aa0; line-height: 1.35; }
.gauge {
  --p: 0; flex-shrink: 0; width: 58px; height: 58px; border-radius: 50%;
  background: conic-gradient(#11cdef calc(var(--p) * 1%), #e4ecf5 0);
  display: flex; align-items: center; justify-content: center; position: relative;
}
.gauge::before { content: ''; position: absolute; inset: 7px; border-radius: 50%; background: #fff; }
.gauge span { position: relative; font-size: .78rem; font-weight: 800; color: #1d3557; }
.gauge-green { background: conic-gradient(#2dce89 calc(var(--p) * 1%), #e4ecf5 0); }
.ins-big { flex-shrink: 0; width: 58px; height: 58px; border-radius: 16px; background: #eef4ff; color: #5e72e4; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.ins-big b { font-size: 1.15rem; line-height: 1; color: #1d3557; }
.ins-big i { font-size: 11px; margin-top: 3px; }
.ins-big-warn { background: #fff1e6; color: #fb6340; }
.tv-row { display: grid; grid-template-columns: minmax(0, 1.4fr) 1fr auto; gap: 10px; align-items: center; padding: 2px 4px; border-radius: 6px; cursor: pointer; }
.tv-row:hover { background: #eef6ff; }
.tv-name { font-size: .72rem; font-weight: 600; color: #344767; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tv-bar { height: 6px; border-radius: 3px; background: #e4ecf5; overflow: hidden; }
.tv-bar span { display: block; height: 100%; border-radius: 3px; background: linear-gradient(90deg, #11cdef, #1171ef); }
.tv-val { font-size: .68rem; font-weight: 700; color: #1d3557; white-space: nowrap; }

/* toolbar */
.status-pills { display: flex; flex-wrap: wrap; gap: 6px; }
.status-pills button { border: 1px solid #dfe6ef; background: #fff; border-radius: 20px; padding: 4px 13px; font-size: .72rem; font-weight: 600; color: #67748e; transition: all .15s; }
.status-pills button:hover { border-color: #11cdef; color: #11a3c9; }
.status-pills button.on { color: #fff; border-color: transparent; }
.status-pills .sp-all.on { background: #344767; }
.status-pills .sp-draft.on { background: #8392ab; }
.status-pills .sp-comparison.on { background: #11a3c9; }
.status-pills .sp-approved.on { background: #5e72e4; }
.status-pills .sp-completed.on { background: #1aae6f; }
.filter-chip { cursor: pointer; }
.quote-legend { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; font-size: .68rem; color: #67748e; }
.quote-legend i { display: inline-block; width: 12px; height: 6px; border-radius: 3px; margin-right: 4px; vertical-align: middle; }
.ql-compare, .qb-compare { background: #2dce89; }
.ql-single, .qb-single { background: #11cdef; }
.ql-none { background: #e4ecf5; }

/* tabel: kolom penawaran & due date */
.quote-cell { min-width: 170px; text-align: left; }
.quote-top, .quote-bottom { display: flex; justify-content: space-between; gap: 8px; font-size: .66rem; color: #67748e; }
.quote-top i { color: #9fb3c8; margin-right: 2px; }
.quote-bar { display: flex; height: 7px; border-radius: 4px; background: #e4ecf5; overflow: hidden; margin: 4px 0 3px; }
.quote-bar span { height: 100%; }
.po-chip { font-weight: 700; color: #5e72e4; background: #eef1ff; border-radius: 4px; padding: 0 5px; }
.due-chip { display: inline-block; font-size: .62rem; font-weight: 700; border-radius: 6px; padding: 1px 7px; margin-top: 2px; }
.dc-over { background: #fde1e6; color: #d6214a; }
.dc-soon { background: #ffe8dc; color: #c2541f; }
.dc-ok { background: #e1f7fb; color: #0a8aa3; }
</style>
